
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/outlet/carts-and-kiosks",
      function () {
        return require("private-next-pages/outlet/carts-and-kiosks.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/outlet/carts-and-kiosks"])
      });
    }
  